import type { SVGProps } from 'react';

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m7.175 12.75 3.3 3.3a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.821.821 0 0 1-.525.25c-.2 0-.383-.083-.55-.25l-4.475-4.475A.861.861 0 0 1 4.65 12c0-.233.092-.442.275-.625L9.4 6.9a.72.72 0 0 1 .525-.225c.217 0 .4.075.55.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525l-3.3 3.3H18.95c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2H7.175Z" />
    </svg>
  );
};
